export default __webpack_public_path__ + "static/media/4.589cda82.jpg";